import { Dialog, DialogProps } from '@mui/material';
import { PropsWithChildren } from 'react';

type FullHeightDialogProps = DialogProps;

const FullHeightDialog = ({ open, onClose, children, ...props }: PropsWithChildren<FullHeightDialogProps>) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      hideBackdrop
      sx={{ '& .MuiDialog-paper': { minHeight: 'calc(100% - 64px)' } }}
      {...props}
    >
      {children}
    </Dialog>
  );
};

export default FullHeightDialog;
